import { Component } from '@angular/core';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-ad-item-banner',
	templateUrl: './ad-item-banner.component.html',
	styleUrls: ['./ad-item-banner.component.scss'],
})
export class AdItemBannerComponent {
	constructor(public readonly localeService: LocaleService) {}
}
